import { render, staticRenderFns } from "./Spreads.vue?vue&type=template&id=352a3f3d&scoped=true&"
import script from "./Spreads.vue?vue&type=script&lang=js&"
export * from "./Spreads.vue?vue&type=script&lang=js&"
import style0 from "./Spreads.vue?vue&type=style&index=0&id=352a3f3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352a3f3d",
  null
  
)

export default component.exports